import { createFileRoute, redirect } from "@tanstack/react-router";

import { Workspace } from "@/lib/types";

export const Route = createFileRoute("/_app/w/")({
  beforeLoad: async ({ context: { zero } }) => {
    const workspace = await new Promise<Workspace | undefined>((resolve) => {
      const view = zero.query.workspaces.one().materialize();
      view.addListener((workspace, resultType) => {
        if (resultType === "complete") {
          resolve(workspace);
        }
      });
    });
    if (workspace) {
      throw redirect({
        to: "/w/$slug",
        params: { slug: workspace.slug },
        replace: true,
      });
    }
  },
});
